import { ReactElement, ReactNode } from 'react';
import { useViewProvider } from '../../contexts/view-provider-context/ViewProvider';
import { PageContentLayoutViewProps } from './PageContentLayoutViewProps';

export function PageContentLayout({ children }: { children: ReactNode }): ReactElement {
  const viewProvider = useViewProvider();
  const viewProps: PageContentLayoutViewProps = {
    children,
  };

  return viewProvider.renderPageContentLayout(viewProps);
}
